import { QUESTION_TYPE } from "./constants";
import { isCorrectKeySensitive } from "./functions";

export const getFormattedAnswer = ({gameState, gameType, keySensitive}) => {
    const isDropdownGame = gameType === QUESTION_TYPE.DROPDOWN;

    const formattedAnswer =
        gameState.textBlanks?.reduce((acc, blank) => {
            if (blank.userAnswer === null) {
                acc[blank.id] = blank;
                return acc;
            }

            const isCorrect = isCorrectKeySensitive(blank.expected, blank.userAnswer, keySensitive);
            acc[blank.id] = {
                ...blank,
                tries: isCorrect ? blank.tries : blank.tries + 1,
                isCorrect
            }
            return acc;
        }, {})
        ??
        gameState.idBlanks?.reduce((acc, blank) => {
            if (blank.fill === null) {
                acc[blank.id] = blank;
                return acc;
            }

            const userAnswer = isDropdownGame ?
                blank.fill
                :
                gameState.words.find(word => word.id === blank.fill)?.data ?? null;

            const isCorrect = isCorrectKeySensitive(blank.expected, userAnswer, keySensitive);
            acc[blank.id] = {
                ...blank,
                userAnswer,
                tries: isCorrect ? blank.tries : blank.tries + 1,
                isCorrect
            }
            return acc;
        }, {});
    
    return formattedAnswer;
}

export const getUpdatedGameState = ({gameState, gameType, keySensitive}) => {
    const isWriting = gameType === QUESTION_TYPE.WRITTING;
    const isDropdownGame = gameType === QUESTION_TYPE.DROPDOWN;

    let writtenWords =
        gameState.textBlanks?.filter(blank => blank.userAnswer).map(blank => {
            const isCorrect = isCorrectKeySensitive(blank.expected, blank.userAnswer, keySensitive) ?? null;
            return {
                ...blank,
                isCorrect,
                tries: isCorrect ? blank.tries : blank.tries + 1
            }
        }) ?? [];

    const newIdBlanks = gameState.idBlanks?.map(blank => {
        if (blank.fill === null) {
            return blank
        }
        const userAnswer = isDropdownGame ?
            blank.fill
            :
            gameState.words.find(word => word.id === blank.fill)?.data ?? null;
        const isCorrect = isCorrectKeySensitive(blank.expected, userAnswer, keySensitive);
        return {
            ...blank,
            isCorrect,
            tries: isCorrect ? blank.tries : blank.tries + 1
        }
    }) ?? null;

    const newGameState = {
        ...gameState,
        textBlanks: gameState.textBlanks?.map(blank => {
            if (blank.userAnswer === null) {
                return blank
            }
            const isCorrect = isCorrectKeySensitive(blank.expected, blank.userAnswer, keySensitive);
            return {
                ...blank,
                isCorrect,
                tries: isCorrect ? blank.tries : blank.tries + 1
            }
        }) ?? null,
        idBlanks: newIdBlanks,
        words: gameState.words.map(word => {
            const blankWithWord = isWriting ?
                writtenWords.find(written => written.userAnswer === word.data) ?? null
                :
                newIdBlanks.find(blank => blank.fill === word.id) ?? null;
            if (isWriting && blankWithWord) {
                const wordIndex = writtenWords.findIndex(writtenWord => writtenWord.userAnswer === word.data);
                writtenWords = writtenWords.slice(0, wordIndex).concat(writtenWords.slice(wordIndex + 1))
            }
            return {
                ...word,
                isCorrect: blankWithWord?.isCorrect ?? null
            }
        })
    }

    return newGameState;
}

export const getTextCorrection = ({alreadyCorrect, gameState, gameType}) => {
    const isWriting = gameType === QUESTION_TYPE.WRITTING;

    const textCorrection = isWriting ?
        gameState.textBlanks?.reduce((acc, word) => {
            if (alreadyCorrect?.includes(word.id)) {
                return acc;
            }
            if (typeof word.isCorrect !== 'boolean') {
                acc[word.id] = 'empty';
            } else {
                acc[word.id] = word.isCorrect ? 'correct' : 'wrong';
            }

            return acc;
        }, {})
        :
        gameState.idBlanks?.reduce((acc, word) => {
            if (alreadyCorrect?.includes(word.id)) {
                return acc;
            }
            if (typeof word.isCorrect !== 'boolean') {
                acc[word.id] = 'empty';
            } else {
                acc[word.id] = word.isCorrect ? 'correct' : 'wrong';
            }

            return acc;
        }, {});
    return textCorrection;
}